<template>
  <UiModal
    :show="showVideo"
    title="视频播放"
    @close="showVideo = false"
  >
    <!-- <xdvideo-player
      :auth="auth"
      :vid="vid"
      :controls="true"
      :loop="false"
      :muted="false"
      :autoplay="true"
    ></xdvideo-player> -->
  </UiModal>
</template>

<script setup>
import { ref } from 'vue'
import UiModal from "@/components/ui-modal.vue";

defineOptions({ name: "StarVideo" });

const showVideo = ref(false);
const vid = ref("");


function play(newVid) {
  vid.value = newVid;
  showVideo.value = true;
}

defineExpose({ play });
</script>

<style lang="scss" scoped>
:deep(.modal__cover) {
  .modal__container {
    background: none;
    max-height: unset;
    .modal__inner {
      .modal__header {
        .title {
          opacity: 0;
        }
      }
      .modal__body {
        border-radius: 0 !important;
      }
    }
  }
}
</style>
